module.exports = __webpack_public_path__ + "static/img/icon-daum.4765654.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/icon-daum.png
// module id = 139
// module chunks = 1